import { ArrowUpRight } from "lucide-react";
import Faq from "../components/Faq";
import { homeFaqs } from "../data/faqs";

// The other four services: Web Design, Design, Social Media and Care Plans are the cards in the hero.
const services = [
  {
    name: "Websites for Contractors",
    desc: "A page for every service and every town you serve, built for excavation, land, and construction businesses.",
    href: "/contractor-websites.html",
  },
  {
    name: "Restaurant Websites",
    desc: "Menus, specials, hours that match Google, and an online ordering button.",
    href: "/restaurant-websites.html",
  },
  {
    name: "Local SEO & Google Business Profile",
    desc: "Your Google profile set up right, a page for every service and town, and weekly tracking of how people find you.",
    href: "/local-seo.html",
  },
  {
    name: "Custom Builds",
    desc: "Booking, customer portals, and web apps, built from scratch and quoted by the job.",
    href: "/custom-builds.html",
  },
];

const link = "text-teal-400 hover:text-teal-300 underline";

const HomeIntro = () => (
  <section className="relative py-20">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-white mb-6">
        Web design and marketing for small businesses in Columbia, MS
      </h2>
      <p className="text-gray-400 leading-relaxed mb-4">
        Rare Works is a small studio based in Columbia, MS. We build custom
        websites, manage social media, and design logos, ads, and print pieces
        for small businesses across South Mississippi. One team handles all of
        it, so your website, your posts, and your branding actually match.
      </p>
      <p className="text-gray-400 leading-relaxed mb-4">
        Our clients include a restaurant, an excavation company, a forestry
        mulching company, and a general contractor. Each has a site we built
        and manage. Our prices are published, the same for every customer.{" "}
        <a href="/our-work.html" className={link}>
          See our work
        </a>{" "}
        or read{" "}
        <a href="/website-cost.html" className={link}>
          what a website costs
        </a>
        .
      </p>
      <p className="text-gray-400 leading-relaxed mb-10">
        We work with businesses in{" "}
        <a href="/web-design-hattiesburg-ms.html" className={link}>Hattiesburg</a>,{" "}
        <a href="/web-design-purvis-ms.html" className={link}>Purvis</a>,{" "}
        <a href="/web-design-petal-ms.html" className={link}>Petal</a>,{" "}
        <a href="/web-design-mccomb-ms.html" className={link}>McComb</a>, and across South Mississippi.
      </p>

      <div className="grid sm:grid-cols-2 gap-4 mb-16">
        {services.map((s) => (
          <a
            key={s.name}
            href={s.href}
            className="group p-6 rounded-2xl glass hover:border-teal-500/50 transition-colors"
          >
            <div className="flex items-start justify-between mb-2">
              <h3 className="text-white font-medium">{s.name}</h3>
              <ArrowUpRight className="w-4 h-4 text-gray-400 group-hover:text-teal-400 transition-colors" />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">{s.desc}</p>
          </a>
        ))}
      </div>

      <Faq items={homeFaqs} />
    </div>
  </section>
);

export default HomeIntro;
